<template>
  <v-layout align-center justify-center>
    <v-flex v-if="sponsor" xs12 lg8>
      <InternalForm
        :visible="showForm"
        :item="sponsor"
        :key="sponsor.id"
        persistent
      />
    </v-flex>
    <v-flex v-else xs12 sm6 md4 lg3>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Sponsor Login</v-toolbar-title>
        </v-toolbar>
        <v-card xs12 class="d-flex justify-center pa-4">
          <v-img
            src="/static/img/logo.png"
            max-width="250"
          ></v-img>
        </v-card>
        <v-card-text>
          <v-form>
            <v-text-field
              prepend-icon="email"
              name="email"
              label="Email"
              type="email"
              v-model="email"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              @keyup.enter="login"
            ></v-text-field>
            <v-text-field
              :append-icon="showpassword ? 'visibility_off' : 'visibility'"
              prepend-icon="lock"
              name="password"
              label="Password"
              id="password"
              :type="showpassword ? 'text' : 'password'"
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              @keyup.enter="login"
              @click:append="() => (showpassword = !showpassword)"
            ></v-text-field>
          </v-form>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>

          <div class="text-xs-center">
            <p><strong>Attention: All activities are logged!</strong></p>
            <p>If you have already registered or your company has been at the St. Paul Rodeo, please login. If you have issues logging in please contact sponsors@stpaulrodeo.com.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="login">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import InternalForm from './sponsorExtern/InternalForm.vue'

export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required }
  },

  components: {
    InternalForm
  },

  data () {
    return {
      showForm: false,
      showpassword: false,
      email: '',
      password: '',
      error: null,
      sponsor: null,
      ip: '',
      name: '',
      title: ''
    }
  },

  created () {
    if (this.$session.get('sponsor')) {
      this.sponsor = this.$session.get('sponsor')
    }

    this.getIp()
  },

  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required.')
      return errors
    }
  },

  methods: {
    cancel () {
      console.log('test1')
      this.sponsor = null
      this.email = ''
      this.password = ''
    },

    async login () {
      this.$v.$touch()

      try {
        const response = await Api().post('sponsor_login/', {
          email: this.email,
          password: this.password,
          ip: this.ip
        })

        this.sponsor = response.data.sponsor

        this.$session.start()
        this.$session.set('sponsor', response.data.sponsor)

        this.password = ''
      } catch (error) {
        this.email = ''
        this.password = ''
        console.log('test2')

        this.error = error.response.data.error
      }
    },

    async getIp () {
      fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
          this.ip = ip
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SponsorLogin.vue